import { graphql } from "react-relay"

export const deVerifyMedicationMutation = graphql`
  mutation deVerifyMedicationMutation($input: De_verifyMedicationInput!) {
    de_verifyMedication(input: $input) {
      medicationVerification {
        id
        ...MedicationVerificationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
